import moment from 'moment';
import { Map, List } from 'immutable';

export const applyFilters = (filters, events = List()) => {
  if (filters.isEmpty()) return events;
  const eventBasedFilters = {
    category: (event, val) => event.get('tags', []).includes(val),
    locale: (event, val) => event.get('short_locale') === val,
    venue: (event, val) => event.getIn(['venue', 'name']) === val,
    city: (event, val) => event.getIn(['venue', 'address', 'city']) === val,
    region: (event, val) => event.getIn(['venue', 'address', 'region']) === val,
    country: (event, val) => event.getIn(['venue', 'address', 'country']) === val,
    month: (event, val) => moment(event.getIn(['date', 'start', 'utc'])).month() === val,
    week: (event, val) => moment(event.getIn(['date', 'start', 'utc'])).day() - 1 === val,
    name: (event, val) =>
      (event.get('title', '') || '').toLowerCase().includes(val.toLowerCase()) ||
      (event.get('description', '') || '').toLowerCase().includes(val.toLowerCase()),
  };
  return events.filter((event) => filters.every((filter, key) => filter.get('values').some((val) => eventBasedFilters[key](event, val.value))));
};

export const venueOptions = (events) =>
  events
    .map((event) =>
      Map({
        label: event.getIn(['venue', 'name']),
        value: event.getIn(['venue', 'name']),
      })
    )
    .filter((f) => f.get('label'))
    .toSet();

export const cityOptions = (events) =>
  events
    .map((event) =>
      Map({
        label: event.getIn(['venue', 'address', 'city']),
        value: event.getIn(['venue', 'address', 'city']),
      })
    )
    .filter((f) => f.get('label'))
    .toSet();

export const regionOptions = (events) =>
  events
    .map((event) =>
      Map({
        label: event.getIn(['venue', 'address', 'region']),
        value: event.getIn(['venue', 'address', 'region']),
      })
    )
    .filter((f) => f.get('label'))
    .toSet();

export const countryOptions = (events) =>
  events
    .map((event) =>
      Map({
        label: event.getIn(['venue', 'address', 'country']),
        value: event.getIn(['venue', 'address', 'country']),
      })
    )
    .filter((f) => f.get('label'))
    .toSet();

export const categoryOptions = (events) => {
  const tags = events.reduce((result, event) => result.concat(event.get('tags')), List());
  const categories = tags
    .toSet()
    .map((t) => ({ label: t, value: t }))
    .filter((t) => t);
  return categories;
};

export const languageOptions = (LANGUAGES_LABELS) => (events) =>
  events
    .map((event) =>
      Map({
        value: event.get('short_locale', 'en'),
        label: LANGUAGES_LABELS[event.get('short_locale', 'en')],
      })
    )
    .toSet()
    .sort((a, b) => a.get('label').localeCompare(b.get('label')));
